import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import moment from 'moment-timezone';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { TextField, Grid } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import DocumentTransaction from 'containers/TransactionManagerTimeLine/OfferRegulation/documents/document';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import { get, isEmpty, isNil } from 'lodash';
import { formatTitleDocument } from 'services/utils';
import { formatBodyOfDocument } from 'containers/TransactionManagerTimeLine/OfferRegulation/utils';
import { translate } from 'containers/services/translate';
import { Listings } from 'containers/AppContainer/typings';
import victimIcon from 'images/victim-icon.svg';
import { BUTTON_COLORS, COLORS } from 'constants/design';
import messages from 'containers/TransactionManagerTimeLine/OfferRegulation/messages';
import { Container } from 'containers/TransactionManagerTimeLine/VictimInfo/styles';
import BeneficiaryCard from 'containers/TransactionManagerTimeLine/OfferRegulation/BeneficiaryCard';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import {
  getLiveDocumentViewUrl,
  openDocument,
} from 'containers/UploadDocuments/utils';
import Document from 'components/Document';
import { DATE_FORMAT, DOCUMENT_TYPES } from 'constants/global';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { toast } from 'react-toastify';
import currentUserStorage from 'containers/services/security/current-user-storage';
import UploadDocument from 'containers/common/UploadDocument';
import { TransactionType } from 'typings/globalTypes';

export interface OfferCardProps {
  intl: IntlShape;
  disableInput?: boolean;
  inputLabelProps?: boolean;
  listings: Listings;
  isReadOnly: boolean;
  offerInfo: any;
  inputProps?: any;
  claimNumber: string;
  transactionInfo: TransactionType;
  claimInfo: any;
  claimId: number;
  policyInfo: any;
  resetUploadedDocument: Function;
  uploadDocument: Function;
  uploadedDocument: any;
  requestAddQuotationDocument?: Function;
  requestGetDocByDocumentumId: Function;
}

const OfferCard: React.FC<OfferCardProps> = (props): JSX.Element => {
  const [offerDocument, setOfferDocument] = useState([]);
  const [receptionDate, setReceptionDate] = useState(null);
  const handleChangeDate = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const receiptDate = moment(theDate as Date).format(DATE_FORMAT);
    setReceptionDate(receiptDate as any);
  };
  useEffect(() => {
    if (!isEmpty(get(props.offerInfo, 'transactionQuotationDocument', []))) {
      setOfferDocument({
        ...get(props.offerInfo, 'transactionQuotationDocument[0]', {}),
      });
      setReceptionDate(
        moment(
          get(
            props.offerInfo,
            'transactionQuotationDocument[0].receptionDate',
            null,
          ) as any,
        ).format('YYYY-MM-DD') as any,
      );
    }
  }, [props.offerInfo, props.transactionInfo]);
  const successCallBack = () => {
    toast.success(translate(messages.uploadSuccess, props));
  };
  const handleValidate = () => {
    if (props.requestAddQuotationDocument) {
      props.requestAddQuotationDocument(
        {
          receptionDate: receptionDate,
          transactionQuotationId: get(props.offerInfo, 'id'),
          url: get(offerDocument, '[0].url', null),
          name: get(offerDocument, '[0].name', null),
          type: get(offerDocument, '[0].type', null),
          content: get(offerDocument, '[0].content', null),
          sagisType: 'Offre et Quittance (Transaction)',
          createdBy: currentUserStorage?.get()?.username,
          claimNumber: get(props.claimInfo, 'claim.claimNumber', null),
          claimId: props.claimId,
        },
        successCallBack,
      );
    }
  };
  const handleChangeDocument = (document: any) => {
    setOfferDocument([document] as any);
  };
  return (
    <Container className="container">
      <div className="victims">
        <div>
          <CustomAccordion
            title={translate(messages.offerTitle, props)}
            textColor={COLORS.ACCORDION_TEXT_BLUE}
            bgColor={COLORS.ACCORDION_BG_BLUE}
            image={victimIcon}
          >
            <div className="victim-container">
              <Grid container direction="row" spacing={2} xs={12}>
                <Grid item xs={4} className="grid-input">
                  <TextField
                    type="number"
                    label={translate(messages.offerIndemnityTitle, props)}
                    className="input-4-1"
                    InputProps={props.inputProps}
                    disabled={true}
                    value={get(props.offerInfo, 'totalOfferAmount')}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={4} className="grid-input">
                  <TextField
                    type="number"
                    label={translate(messages.responsability, props)}
                    className="input-4-1"
                    InputProps={props.inputProps}
                    disabled={true}
                    value={get(props.offerInfo, 'responsabilityRate')}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={4} className="grid-input">
                  <TextField
                    type="number"
                    label={'Montant offre'}
                    className="input-4-1"
                    InputProps={props.inputProps}
                    disabled={true}
                    value={get(props.offerInfo, 'offerAmount')}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
              {get(props.transactionInfo, 'victim.injuryPostKey', {}) ===
                INJURY_POST_DECEASED &&
                !isEmpty(get(props.offerInfo, 'nextOfKins', [])) && (
                  <BeneficiaryCard offerInfo={props.offerInfo} />
                )}
              <Grid xs={12}>
                <DocumentTransaction
                  body={formatBodyOfDocument(
                    props.claimNumber,
                    props.transactionInfo,
                    props.claimInfo,
                    props.policyInfo,
                    props.offerInfo,
                    props.listings,
                  )}
                />
              </Grid>

              <Grid
                container
                direction="row"
                xs={12}
                alignItems="center"
                spacing={2}
              >
                {isEmpty(
                  get(props.offerInfo, 'transactionQuotationDocument', []),
                ) && !props.isReadOnly ? (
                  <Grid item xs={4} style={{ marginTop: 12, paddingRight: 37 }}>
                    <span style={{ fontSize: '13px', color: 'red' }}>
                      {translate(messages.addDocumentTitle, props)}
                    </span>
                    <UploadDocument
                      index={0}
                      name={formatTitleDocument(0)}
                      type={DOCUMENT_TYPES.QUITTANCE_TRANSACTION}
                      setDocumentState={handleChangeDocument}
                      documentState={offerDocument}
                    />
                  </Grid>
                ) : !isEmpty(
                    get(props.offerInfo, 'transactionQuotationDocument', []),
                  ) ? (
                  <Grid item xs={4} style={{ marginTop: 12, paddingRight: 37 }}>
                    <Document
                      name={get(offerDocument, 'name', '')}
                      type={get(offerDocument, 'type', '')}
                      icon={
                        <VisibilityIcon
                          className="consult"
                          onClick={() => {
                            if (
                              !isNil(get(offerDocument, 'documentumId', null))
                            ) {
                              props.requestGetDocByDocumentumId(
                                getLiveDocumentViewUrl(
                                  '' as any,
                                  '',
                                  true,
                                  get(offerDocument, 'documentumId', null),
                                ),
                              );
                            } else {
                              openDocument(
                                get(
                                  props.offerInfo,
                                  'transactionQuotationDocument.url',
                                  null,
                                ),
                              )();
                            }
                          }}
                        />
                      }
                    />
                  </Grid>
                ) : (
                  <></>
                )}

                <Grid
                  item
                  xs={3}
                  style={{
                    marginTop: isEmpty(
                      get(props.offerInfo, 'transactionQuotationDocument', []),
                    )
                      ? 38
                      : 12,
                  }}
                >
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={frLocale}
                  >
                    <KeyboardDatePicker
                      autoOk
                      disableFuture
                      variant="inline"
                      invalidDateMessage=""
                      format="dd/MM/yyyy"
                      id="receptionDate"
                      onChange={handleChangeDate}
                      name={'RECEPTION_DATE'}
                      value={dateStringToLocalDate(receptionDate as any)}
                      label={translate({ ...messages.dateReception }, props)}
                      style={{ width: '100%' }}
                      InputLabelProps={{
                        shrink: !!receptionDate,
                        classes: { root: 'label-input' },
                      }}
                      disabled={props.isReadOnly}
                      error={
                        !props.isReadOnly &&
                        (new Date(receptionDate as any) > new Date() ||
                          receptionDate === ('' as any) ||
                          receptionDate === null ||
                          moment(receptionDate).format(DATE_FORMAT) ===
                            'Invalid date' ||
                          receptionDate === ('Invalid Date' as any))
                      }
                      helperText={
                        !props.isReadOnly &&
                        (new Date(receptionDate as any) > new Date() ||
                          receptionDate === ('' as any) ||
                          receptionDate === null ||
                          moment(receptionDate).format(DATE_FORMAT) ===
                            'Invalid date' ||
                          receptionDate === ('Invalid Date' as any))
                          ? translate(messages.invalidDate, props)
                          : ''
                      }
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={4} style={{ marginTop: 38 }}>
                  {!props.isReadOnly &&
                    isEmpty(
                      get(props.offerInfo, 'transactionQuotationDocument', []),
                    ) && (
                      <PrimaryButton
                        data-testid="validate"
                        background={BUTTON_COLORS.PRIMARY_BLUE}
                        border={BUTTON_COLORS.PRIMARY_BLUE}
                        titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                        title={translate(messages.validatedButtonTitle, props)}
                        onClick={handleValidate}
                      />
                    )}
                </Grid>
              </Grid>
            </div>
          </CustomAccordion>
        </div>
      </div>
    </Container>
  );
};
export default injectIntl(OfferCard);
